module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home row",
    attrs: {
      "id": "fwc"
    }
  }, [_c('div', {
    staticClass: "acol wideDesign"
  }, [_c('news', {
    attrs: {
      "image": "2031.jpg",
      "link": "https://ilgiornaledellarchitettura.com/2025/12/03/a-torino-il-laboratorio-hi-tech-e-in-un-garage/",
      "titolo": "IAAD Garage in Il Giornale dell'Architettura "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("IAAD establishes new educational spaces inside the former Ceat building in Turin, a space designed by Dap Studio that is now taking on a new lease of life, hosting hi-tech laboratories ready to support students in their design courses.")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "2030.jpg",
      "link": "https://www.theplan.it/architettura/riuso-lambrate-dap-studio-milano",
      "titolo": "A courtyard that becomes a city"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The Riuso Lambrate project has been published in The Plan and featured in several architecture magazines."), _c('br'), _vm._v("The wide media coverage confirms the strong interest in themes of reuse and transformation of the existing built environment.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "2029.jpg",
      "link": "",
      "titolo": "Civic Center and urban regeneration in Malnate"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Work continues on the new Civic Centre, a project that includes numerous services for citizens, a large and functional library, and new office space. The project aims to create a landmark for the community, combining functionality, accessibility, and spatial quality")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2025.jpg",
      "link": "/inside/progetto/p143",
      "titolo": "Endine, new office building"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("An architectural enclosure brings together workspaces and open courtyards, amplifying the presence and volumetric perception of the building")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2024.jpg",
      "link": "https://www.dedalominosse.org/ita/#",
      "titolo": "Dedalo Minosse Award"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("2025 Edition: Mezzolombardo Library included in the selected projects for the exhibition at the Basilica Palladiana")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2023.jpg",
      "link": "/inside/progetto/p141",
      "titolo": "Design competition for the Grigoletti Primary School in Pordenone"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The project for the new Grigoletti Primary School proposes an open, experiential, and inclusive educational model, capable of redefining the relationship between school and society")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2021.jpg",
      "link": "",
      "titolo": "Strategies for the Regeneration of the Built Environment in Milan"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The studio proposes the redevelopment of a centrally located building through a corner void intervention that enhances its legibility and openness. The façades, contemporary yet inspired by Milanese tradition, transform the volume into an identity-defining element within the urban fabric.")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "2018.jpg",
      "link": "/inside/news/n2018",
      "titolo": "Urban regeneration of the historic center and new centralities"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("As part of a broader urban regeneration strategy for the center of Parabiago, DAP studio is developing a unified project articulated into areas with specific identities and functions. Within this framework, two key interventions are being developed: the redevelopment of Piazza Maggiolini, at the heart of the historic center, and the new entrance square to the Cultural Center in the former Rede hosiery factory area.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "2019.jpg",
      "link": "https://www.artribune.com/progettazione/2025/04/intervista-elena-sacco-dap-studio/",
      "titolo": "Designing Within the Existing: DAP Studio on Artribune"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Elena Sacco, partner at DAP Studio, was interviewed by Artribune to discuss the studio’s approach to working with existing architecture — a process rooted in dialogue with the urban context and the creation of new relationships.")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2012.jpg",
      "link": "https://vimeo.com/1063490318",
      "titolo": "TEMPORARY LIVING. NEW RESIDENCES FOR UPTOHOME "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The new UPTOHOME residence, an accommodation facility located in the east of Milan, is nearing completion. All the apartments of UPTOHOME have been designed by DAP studio, which has been working for many years on temporary living in its various forms."), _c('br'), _vm._v("At this link some phases of the construction site’")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2013.jpg",
      "link": "https://villamaddalena.info/",
      "titolo": "IN THE HEART OF MONFERRATO"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio has carried out the renovation of a villa designed by the firm in the 1990s, reconfiguring it to accommodate its new use as a holiday home. The intervention included the swimming pool, garden, interior furnishings, and sustainability features, with photovoltaic panels on the roof and an electric car charging station.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2016.jpg",
      "link": "https://ntplusentilocaliedilizia.ilsole24ore.com/art/immobiliare-sfida-rigenerazione-progettare-nuovo-sull-esistente-AGZFFUcB?refresh_ce=1",
      "titolo": "THE CHALLENGE OF REGENERATION: DESIGNING THE NEW ON THE EXISTING  "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("When new meets existing, new architecture is born, writes Maria Chiara Voci in Real Estate 24, and she addresses this issue by illustrating the redevelopment of the Ex Banco di Sicilia in Turin, whose works are currently underway. The project was developed by DAP studio with 3+Progetti, Prof Gasparoli and Projema Engineering.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2010.jpg",
      "link": "https://siat.torino.it/tour/addition-in-architecture-il-progetto-del-nuovo-nellesistente-giornate-di-studio-e-call-aperta-per-giovani-professionisti/",
      "titolo": "ADDITION IN ARCHITECTURE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio is speaking on 28/11 at the conference, promoted by SIAT, at the Faculty of Architecture, Salone d’Onore, Castello del Valentino. The conference aims to offer a selection of the projects in Italy and Europe that, by grafting new forms and materials onto existing buildings, generate new situations of balance.")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "2008.jpg",
      "link": "https://archello.com/news/archello-awards-2024-longlist-library-building-of-the-year",
      "titolo": "THE MEZZOLOMBARDO LIBRARY ON THE ARCHELLO AWARDS LONGLIST"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The Library of Mezzolombardo has been selected, along with five other projects, for the Library Building of the Year category in the 2024 edition. The winners will be announced on 31 January 2025, after an evaluation by an international jury and the readers' vote through the platform: vote for us!")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "2009.jpg",
      "link": "https://gangemi.com/prodotto/yearbook-8/",
      "titolo": "YEARBOOK 2023"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The Mezzolombardo Library is among the projects selected and published in the 2023 edition of the Yearbook, a publication promoted by the CNAPPC and edited by Alessandra Ferrari.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "2007.jpg",
      "link": "https://cultlabtorino.com/cult-hub/",
      "titolo": "ARCHITECTURE EVENINGS IN TURIN: PROJECTS FOR THE PUBLIC CITY"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("On the 17th of October 2024 in Turin at @ultraspazio_club we will participate in Le Serate di Architettura by @cultlabtorino, in order to explore how public architecture can revitalise contemporary cities.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "2003.jpg",
      "link": "https://www.mediterraneiinvisibili.com/edizione-2024/",
      "titolo": "LA BIENNALE DELLO STRETTO 2024"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Our urban regeneration project for the municipality of Garbagnate will be presented until the 14th of December at the Biennale dello Stretto 2024, curated by Mariangela Cama, Alfonso Femia and Francesca Moraci.")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2004.png",
      "link": "https://drive.google.com/file/d/1ICMAv9P3cyjv9xS6ukNeKNASLMZPo_ML/view",
      "titolo": "THE LIVELY SQUARE IN A SHORT FILM"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("At the Biennale dello Stretto 2024 will also be presented the Alberto Danelli's short film Piazza Giardino, winner of the ‘Contemporaneamente’ video contest launched by Ordine degli Architetti di Genova, shortlisted for the 2021 Dezeen Awards and among the finalists of the Venice Architecture Short Film Festival ‘Living together again’")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2000.jpg",
      "link": "/inside/progetto/p138",
      "titolo": "MEZZOLOMBARDO LIBRARY"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP Studio has conceived a versatile space that facilitates the simultaneous performance of different activities. With more than 1000 square metres at its disposal, the facility houses the library proper, a modern multi-purpose hall and study rooms open 24 hours a day.")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1097.jpg",
      "link": "/inside/progetto/p137",
      "titolo": "REDEVELOPMENT OF THE FORMER CASERMA GARIBALDI IN VARESE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The executive project for the second lot of the new Cultural Hub in Varese has been completed. The former Garibaldi Caserma will house spaces and services for culture, education, leisure, and social activities")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1098.jpg",
      "link": "/inside/news/n1098",
      "titolo": "GINORI MUSEUM, CONSTRUCTION SITE STARTS"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("With the opening of the  site to the construction company on May 21, the renovation of the Museo Ginori designed by DAP Studio in team with 3+Progetti and Projema Engineering, is now in full swing")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1095.jpg",
      "link": "/inside/news/n1095",
      "titolo": "LIBRARY CRP TORINO, WORK IN PROGRESS"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Renovation works are underway on the former Banco di Sicilia, a protected building in the center of Turin, for the construction of the new Library of the Regional Council of Piedmont")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1093.jpg",
      "link": "/inside/progetto/p134",
      "titolo": "CULTURAL CENTRE MARCONI"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The Cultural Centre in piazza Marconi, heart of Pero's urban system, is the first piece of the overall urban regeneration project commissioned to DAP studio. It will house cultural spaces and  services for the community: library, exhibition spaces, auditorium, bar, course spaces and coworking")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1088.jpg",
      "link": "https://anci.lombardia.it/dettaglio-news/20227151641-spazio-alla-scuola-presentati-i-progetti-dei-comuni-vincitori-del-bando-regionale/",
      "titolo": "TRAVAINI SCHOOL WINS REGIONAL FUNDING"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The conference at Anci headquarters in Milan, presents the Travaini elementary school in Parabiago designed by DAP studio, one of the 9 projects accepted for funding against 120 applications: a school conceived as a real Civic Center, a reference point for the community of students and a place open to the city.")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1086.jpg",
      "link": "/inside/progetto/p135",
      "titolo": "Strategic Urban Project for the public space"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The Strategic Urban Project for the public space, commissioned to DAP studio by the Municipality of Pero, anticipated the revision of the PGT and expresses a vision of the future city.Thanks to this project, the Administration has been able to access to PNRR funds")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1087.jpg",
      "link": "https://www.ilqi.it/convegni/220526e01",
      "titolo": "Progetti & Cantieri d’Italia 2022, auditorium Assimpredil Milan"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The conference illustrates the main real estate projects in progress across Italy. "), _c('br'), _vm._v("Elena Sacco is invited to present the Rede Cultural Centre, one of the latest projects by DAP studio. A regeneration project for a 14,000-square-meter industrial building that will house services for citizens, spaces for culture and leisure.")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1085.jpg",
      "link": "/inside/progetto/p136",
      "titolo": "CENTRO CULTURALE REDE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio designs the transformation of the Calzificio Rede,bridge-shaped industrial building: a large multifunctional civic hub that will house services, cultural and leisure spaces.")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1084.jpg",
      "link": "https://issuu.com/dida-unifi/docs/dieci_progetti_per_la_qualita_abitativa_maria_de",
      "titolo": "Ten Projects for Housing Quality"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Abitare Toscana and InvestiRE SGR promoted the publication of the book “Ten Projects for Housing Quality,” edited by Maria De Sanctis. DAP studio is one of the selected firms with a proposal developed in collaboration with Claudio Bossi of the social cooperative La Cordata.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1082.jpg",
      "link": "https://www.arkitectureonweb.com/en/-/projects/fuori-dalle-righe",
      "titolo": "Fitting room n. 16 on archweb"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The Camerino designed by DAP studio for the Arcimboldi theater published on Archweb")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1079.jpg",
      "link": "https://interioresminimalistas.com/tag/dap-studio/",
      "titolo": "VILLA EN SICILIA: FUSIONAR ARQUITECTURA Y NATURALEZA"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Spanish magazine Interiores Minimalistas, which covers design and interior architecture, publishes the interiors of the villa in Sicily")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1076.jpg",
      "link": "https://www.mediterraneiinvisibili.com/",
      "titolo": "Mediterranei Invisibili. La Biennale dello Stretto"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio participates with the project Villa in Sicilia in the “Biennale dello Stretto” 2022, a multidisciplinary event that includes contemporary art exhibitions, performances, workshops and cultural events.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1083.jpg",
      "link": "https://www.youtube.com/watch?v=J06e5uio45c",
      "titolo": "Encuentros"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Elena Sacco meets Giorgio Tartaro and  tells about DAP studio's interpretation of wood in design at Encuentros by Finsa. ")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1075.jpg",
      "link": "https://www.dezeen.com/awards/2021/shortlists/media/architecture-video-of-the-year/",
      "titolo": "Shorlisted Deezen Awards 2021"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The video Piazza Giardino by Alberto Danelli  has made it onto the Dezeen Awards 2021 shortlist. From over 4.700 entries from 87 countries to Dezeen Awards, the project is one of 5 videos  in the running  in the \"media\" category")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1071.jpg",
      "link": "#!",
      "titolo": "Regional Council Library of Turin "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("A new project for the promotion of culture in Turin on behalf of the Regional Council. The former Banco di Sicilia, a building  protected by the Superintendence of Cultural Heritage  in the heart of the city, will become the new Library. ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1072.jpg",
      "link": "/inside/progetto/p130",
      "titolo": "Quality of Living. #ViviBusto2030 admitted for funding"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Social housing, culture, public life, mobility: # ViviBusto2030, the project by DAP studio for Busto Arsizio, has been admitted to the funding available by the National Innovative Program for the Quality of Living.")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1069.jpg",
      "link": "https://www.marieclaire.com/it/casa/case-arredamento/a36047963/dapstudio-architettura-sicilia/",
      "titolo": "A house in Sicily:: former tool shed, today a delicate domestic eden "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Marie Claire writes about the Villa in Sicily \"On one side the Ionian Sea, on the other Etna. It is on these ancient dry stone terraces that the prohect by  DAP Studio has given life to the hospitable nest of a successful IT entrepreneur ... \"")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1067.jpg",
      "link": "#!",
      "titolo": "Best Internationl Houses"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Villa in Sicilia by DAP studio is included in the Best International Houses exhibition, organized by Platform at the same time as the Architecture Biennale in Venice. ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1068.jpg",
      "link": "https://www.teatroarcimboldi.it/fat-event/vietato-lingresso/",
      "titolo": "Vietato l'ingresso"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio is one of the designer invited by the Arcimboldi Theater to design the 17 dressing rooms: 17 places where magic is born and which will be transformed with a heterogeneous proposal, just like the great artists who live there: actors, singers, dancers, musicians. An unprecedented project that allows the theater to reopen to the public in an unconventional way, after a year of forced closure.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1061.jpg",
      "link": "/inside/progetto/p130",
      "titolo": "#viviBusto 2030"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Social housing, culture, public life, mobility: # ViviBusto2030 is the name of the project  by DAP studio, made for the municipality of Busto Arsizio. It involves more than 18,000 square meters of surface, distributed in 5 areas of the city centre that will undergo interventions of redevelopment and regeneration. ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1062.jpg",
      "link": "/inside/progetto/p127",
      "titolo": "A school open to the city"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio’s project is among the 5 selected in Petriolo as part of the competition for the building of a new school, a place of learning for children but also a real civic center open to the whole city. ")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1058.jpg",
      "link": "/inside/progetto/p129",
      "titolo": "Villa in Sicily, an observatory on the landscape "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Surrounded by the amazing landscape of north-eastern Sicily, the project by DAP studio transforms a former warehouse into an elegant hospitable nest. With a rooftop swimming pool. ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1064.jpg",
      "link": "/inside/news/n1064",
      "titolo": "I MAESTRI DELL'ARCHITETTURA / COLLECTOR'S EDITION"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The issue dedicated to DAP studio has been published.  “I maestri dell’architettura” is a series of collectible illustrated monographs, on the protagonists of contemporary architecture in Italy and abroad. Each volume of this editorial project, curated by Angelica Di Virgilio, addresses the work of a different architect through interviews, drawings, photographs, descriptions.  The monographs are also available online at www.hachette-fascicoli.it")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1055.jpg",
      "link": "https://vimeo.com/434340070",
      "titolo": "VENICE ARCHITECTURE SHORT FILM FESTIVAL"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The garden-square designed by DAP studio is the subject of a short film, written and directed by Alberto Danelli, which placed among the 20 finalists of the Venice Architecture Short Film Festival 2020, organized by ArchiTuned . The theme of the International Festival, Living together again, is well suited to this redevelopment project. The 20 selected films were screened from the 1 st to 5 th of September in Venezia at the Cloister of San Francesco della Vigna and the Pavilion in the Giardini della Biennale.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1056.jpg",
      "link": "#!",
      "titolo": "IN/ARCHITETTURA AWARD 2020"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Honourable mention in the Urban Regeneration category to the Teca Theater, the Music Center, designed by DAP studio, which also includes outdoor areas  of 7 thousand square meters The Award Ceremony of the In/Architettura 2020 Lombardia and Emilia Romagna Awards took place in Milan on the 15 th  of October. ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1052.jpg",
      "link": "https://www.domusweb.it/it/architettura/gallery/2020/10/29/a-garbagnate-milanese-un-vuoto-urbano-diventa-la-nuova-piazza-di-quartiere.html",
      "titolo": "PIAZZA-GIARDINO SU DOMUSWEB"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio  redesigned an abandoned suburban area of 2500 square meters, making it a new landmark for the town of Garbagnate Milanese.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1053.jpg",
      "link": "https://www.archilovers.com/projects/269600/palestro-3.html",
      "titolo": "BEST ARCHILOVERS 2020"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Palestro 3 Residence designed for Reale Immobili is one of the  Best Archilovers 2020")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1051.jpg",
      "link": "https://www.conventodicampo.it/index.html",
      "titolo": "IDEAS FOR THE EX CONVENT"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Paolo Danelli and Carlo Alberto Maggiore are the tutors of the design workshops for the redevelopment of the Campo Convent. This is the conclusion of a participatory process, coordinated by Avventura Urbana, for the reconversion of the Convent of Campo Lomaso (Trento) which involved institutions, associations and inhabitants of the valley.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1050.jpg",
      "link": "https://bigsee.eu/via-monviso-garden-square-garbagnate-milano/",
      "titolo": "BIGSEE AWARD ARCHITECTURE 2020"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("BigSEE Award 2020 to DAP studio for the square-garden project. BIG SEE is a creative platform that promotes creative excellence in South Eastern Europe. Bringing together 19 countries and 350 million people, BIG SEE represents a unique forum for the discussion and development of the cultural, economic and political role of this area of the planet.")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1045.jpg",
      "link": "/inside/progetto/p108",
      "titolo": "SOCIAL HOUSING SAMPIERDARENA, THE RED WIRE OF LIVING "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The new Social Housing residence designed by DAP studio on behalf of DeA Capital opens to the public. \"Sampierdarena\" is an initiative by the Liguria Social Housing Fund that has enabled the conversion between a former office building and the realisation of comfortable apartments accessible to all. The welcoming hall and the common spaces are perfectly suitable for small gatherings and community activities, giving the opportunity to the inhabitants to write a new life chapter together in this ideal place. The colour, like a red wire of living, accompanies the spaces of relationship from the hall on the top floor.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1044.jpg",
      "link": "/inside/progetto/p87",
      "titolo": "VIA MONVISO GARDEN-SQUARE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The construction works for via Monviso Garden-Square in Garbagnate have been completed.  When we were asked to redevelop the area, we wondered about the real/intrinsic nature of this site in a state of decay, in which only trees have been able to last despite the abandonment . And it is precisely from these trees that we started designing our project, integrating them into a design in which the image of the garden and the idea of the square can merge.  ")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1034.jpg",
      "link": "/inside/progetto/p14",
      "titolo": "RE-READINGS, RIBA PUBLISHING"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Rereadings  is a testament to the growing interest and demand for clarification of the remodelling, adaptation and transformation processes within the existing built environment.  The book explores how the remodelling of existing buildings is a sustrainable and viable alternative to the construction of new buildings. Elsa Morante Library by DAP studio, is one of the case studies analysed by the authors Graeme Brooker and Sally Stone ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1046.jpg",
      "link": "#!",
      "titolo": "ITALIAN ARCHITECTURE OF THE THIRD MILLENNIUM"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The generation of Italian architects who came after the \"golden age\" of the 60s and 70s, according to a widespread opinion, seems to have lost the ability to influence the culture of the project. With the new millennium, a different way of approaching the project towards the environment in which society lives and works has emerged. The author proposes an itinerary through 10 Italian regions and presents a selection of projects, including some buildings by DAP studio. ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1041.jpg",
      "link": "#!",
      "titolo": "SCALO FARINI, 5 TEAMS SELECTED DAP STUDIO IS IN THE GRIMSHAW’S TEAM "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The first phase of the competition launched by Fs Sistemi Urbani and Coima for the redevelopment of the Farini and San Cristoforo railway yard is closed. Names of worldwide fame together with important Italian names were selected by the jury chaired by Perrault. Sir Nicolas Grimshaw, one of the masters of contemporary British architecture, believes in the potential of a British-Italian team, which brings together all the expertise: the experience in the fields of urban regeneration of Urban Silence, the great knowledge of Elioth and the competences of the Italian firms Antonio Perazzi, Sec and Dap studio ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1042.jpg",
      "link": "https://www.theplan.it/webzine/architettura-italiana/centro-della-musica-a-cassano-d-adda-dap-studio",
      "titolo": "THE MUSIC CENTER ON THE PLAN"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The Center for Music at Cassano d’Adda expresses an idea of architecture as a way of creating a place of exalted functions and public significance, Francesco Pagliari writes on The Plan. The pictures are by Filippo Romano, the model was made by Alessandro Battistella")])])], 1), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1037.jpg",
      "link": "/inside/progetto/p126",
      "titolo": "R&D REGAS CENTER"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The strategic importance that Regas attributes to the Research and Development sector led to the acquisition of the former Snam Rete Gas building in Treviglio and the surrounding site to transform it into its R&D Center. The site has a total area of 13,000 square meters and includes a building entirely surrounded by a large park. The choice of a green location underlines the company's growing attention to nature and the environment. DAP studio has been invited to participate in the competition for the construction of the new headquarters.")])]), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1038.jpg",
      "link": "#!",
      "titolo": "ARCHICHAT NIGHT"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The Archichat Night event, held at the Fabbrica del Vapore, organized by the RebelArchitette team and thanks to the hospitality of the Viafarini association and under the patronage of the Order of Architects of Milan, was an opportunity for a rich in-depth analysis on the diversity of approaches to contemporary architecture thanks to the intervention of five Milanese lecturers. Laura Berni (Lascia la scia), Selina Bertola (Nomade), Silvia Calatroni (SdArch), Elena Sacco (DAP studio) and Isabella Inti (Tempo Riuso) illustrated their educational and professional path together with their most significant projects.")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1040.jpg",
      "link": "http://www.ediliziaeterritorio.ilsole24ore.com/art/progettazione-e-architettura/2018-09-13/a-cassano-d-adda-centro-la-musica-firmato-dap-studio-144604.php?uuid=AELzjjrF",
      "titolo": "DAP STUDIO ON EDILIZIA E TERRITORIO"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("In Cassano d’Adda the municipal Center for Music is signed by Dap studio, Mariagrazia Barletta writes in her article on Edilizia e Territorio, daily newspaper of Il Sole 24 Ore")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign",
    staticStyle: {
      "clear": "left"
    }
  }, [_c('news', {
    attrs: {
      "image": "1031.jpg",
      "link": "#!",
      "titolo": "MILAN CAPITAL OF THE MODERN"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The book, edited by Lorenzo Degli Esposti, investigate the relationships between modern architecture and the city of Milan, between single and specific works and the large scale of the urban territory. In addition to the map of 99 \"classic\" modern architectures, the book proposes other 77  projects built after 2000, including some DAP studio works.  ")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "acol halfDesign"
  }, [_c('news', {
    attrs: {
      "image": "1033.jpg",
      "link": "/inside/progetto/p125",
      "titolo": "URBAN CENTER COMPETITON, MILAN"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio is among the architectural offices invited to the competition for the new Urban Center at the Milan Triennale. The jury for the selection of candidates (composed of: Stefano Boeri, president of  La Triennale Foundation in Milan; Alberto Artioli, director of the Foundation; Lorenza Baroncelli, curator of the Architecture, Urban and City Regeneration Sector; Paolo Brambilla, representative of the Milan Architects Order; Cino Zucchi, President of the jury) has chosen seven design groups.")])])], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "acol shortDesign"
  }, [_c('news', {
    attrs: {
      "image": "2032.jpg",
      "link": "https://vimeo.com/1168188914?share=copy&fl=sv&fe=ci",
      "titolo": "Reuse Lambrate between construction site and shots by Marco Introini"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Alberto Danelli’s video narrates the building's transformation from a production space to a residence, alternating images of the construction site with behind-the-scenes footage from Marco Introini’s photo shoot. Two distant moments that, in the end, converge until they overlap. The result is a powerful contrast: on one side, the construction site, a living organism advancing from the depths; on the other, the staged life of the photographs, composed of carefully positioned figures.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2028.jpg",
      "link": "/inside/progetto/p144",
      "titolo": "Ex Cinema Corso. Contemporary Art Incubator"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The former cinema is transformed into a Laboratory for Contemporary Art experimentation: a flexible, multifunctional space capable of hosting visual arts, performances, screenings, and participatory events. The project integrates technological infrastructure suited to contemporary artistic practices while enhancing the historic identity of the former cinema.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2027.jpg",
      "link": "",
      "titolo": "Cultural center, Levico Terme"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP Studio is working on the project for the new Cultural Center, an opportunity to respond organically to the community’s needs  and, at the same time, strengthen Levico Terme’s role as a hub for cultural production and enjoyment, also in relation to the tourist flows that affect the town for most of the year.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2026.jpg",
      "link": "/inside/progetto/p145",
      "titolo": "Lambrate. A Reuse Project"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Within the context of urban regeneration in East Milan, a building located within a courtyard has been transformed from a workshop into temporary residences, enhancing interior spaces, outdoor areas, and overall architectural quality.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2022.jpg",
      "link": "https://www.rigenerareggioemilia.it/i-selezionati-del-premio-architettura-rigenera-ii-edizione/",
      "titolo": "DAP studio selected as one of the ten national finalists for the Rigenera Award 2025"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The Jury of the Rigenera Award has selected the ten national finalists for the second edition of the competition. The designers will present their projects to the public and the commission on April 7, 2025.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2020.jpg",
      "link": "",
      "titolo": "Exploring Architectural Practices and Visions – Seminar in Barone Canavese"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio is one of eight practices invited to the seminar held on May 24–25 in Barone Canavese, curated by Davide Derossi, Franco Lattes, and In/Arch Piemonte. An opportunity for dialogue among architects on practices and visions of contemporary architecture.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2011.jpg",
      "link": "https://www.architettinovaravco.it/page/OPEN_Architettura_aperta_2025._SPAZI_PUBBLICI_E_PRIVATI_IN_DIALOGO-1%C2%B0_incontro_DAP_STUDIO%3A_ELENA_SACCO%2C_PAOLO_DANELLI_5299",
      "titolo": "PRIVATE AND PUBLIC SPACES IN DIALOGUE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("On Thursday 20 February, DAP studio will inaugurate the cycle of meetings promoted in Verbania by the Order of Architects, in collaboration with the Landscape Museum Study Centre, as part of the OPEN Architecture 2025 event.  We will talk about public projects but also discuss the role of private interventions in the construction of public spaces.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2014.jpg",
      "link": "/inside/progetto/p140",
      "titolo": "REHEARSAL HALL OF THE OPERA HOUSE OF ROMA CAPITALE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The design proposal developed as part of the competition aims to create a technical-educational hub linked to the Teatro dell'Opera di Roma. The plan includes the construction of a stage design rehearsal room serving the Theater, which can also be open to the local community.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2015.jpg",
      "link": "https://www.artribune.com/progettazione/architettura/2024/11/savona-rigenerazione-capitale-cultura-2027/",
      "titolo": "NEW ROUTES FOR CULTURE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("With the project ‘New routes for culture’, directed by Paolo Verri, Savona is competing for the title of Italian Capital of Culture 2027. The article in Artribune talks about Palazzo della Rovere and DAP studio, which is overseeing the interior design and the integrated identity and image project.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2002.jpg",
      "link": "https://www.dapstudio.com/site/inside/news/n1099",
      "titolo": "THE LIVELY SQUARE IN A SHORT FILM "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("At the Biennale dello Stretto 2024 will also be presented the Alberto Danelli's short film Piazza Giardino, winner of the  ‘Contemporaneamente’ video contest launched by Ordine degli Architetti di Genova, shortlisted for the 2021 Dezeen Awards and among the finalists of the Venice Architecture Short Film Festival ‘Living together again’")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2006.jpg",
      "link": "https://architettibergamo.it/racconti-di-architettura-dap-studio-housing-sociale-come-strumento-di-rigenerazione-urbana/",
      "titolo": "RACCONTI DI ARCHITETTURA. DAP STUDIO: HOUSING SOCIALE COME STRUMENTO DI RIGENERAZIONE URBANA"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The webinar of the evening that hosted Elena Sacco and Michele Cortinovis in the  Racconti di Architettura Cycle is available on the website of the Ordine degli Architetti PPC di Bergamo")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2005.jpg",
      "link": "https://www.presstletter.com/2024/10/architects-meet-in-lecce-hyperregionalism/",
      "titolo": "HYPER REGIONALISM. ARCHITECTS MEET IN LECCE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("From the 24th to 26th of October we participate in the event organized by the Associazione Italiana di Architettura e Critica (Aiac) in Lecce. Our Library of Mezzolombardo is exhibited at the church of Santa Maria di Ognibene, within the HyperRegionalism exhibition.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "2001.jpg",
      "link": "https://www.thebrief.city/stories/progettare-la-citta-pubblica-il-metodo-dap-studio/",
      "titolo": "DESIGNING THE PUBLIC CITY. THE DAP STUDIO APPROACH"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Claudia Brivio interviews Elena Sacco and Paolo Danelli, founders of DAP studio. From their origins to their recent collaborations with municipalities, they talk about their method and experience in designing the public city, thanks also to the push for urban regeneration provided by the Pnrr and Pinqua.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1099.jpg",
      "link": "https://www.comune.savona.it/it/aree-tematiche/interventi-e-programmi-di-riqualificazione-urbana/piano-di-valorizzazione-palazzo-della-rovere/programma-di-valorizzazione.html",
      "titolo": "PALAZZO DELLA ROVERE IN SAVONA"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The renovation of Palazzo della Rovere, which will host a new cultural center and library, funded by the PNRR, has been initiated. DAP Studio was commissioned to design the interior spaces and and the integrated identity and image project for the Center.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1096.jpg",
      "link": "https://www.silvanaeditoriale.it/libro/9788836656257",
      "titolo": "ATLANTE DELLE ARCHITETTURE NELLA PROVINCIA DI VARESE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Three projects by DAP Studio have been included by Luciano Crespi among the must-see places selected in his Atlante")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1094.jpg",
      "link": "https://www.dapstudio.com/site/documents/Pesaro-2024_MOSTRA_locandina_programma_50x70.pdf",
      "titolo": "PESARO CAPITALE DELLA CULTURA 2024"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio's Elsa Morante Civic Library will be part of the selection of projects “Architectures for the Community of the Present,”  exhibition organized by the National Council of Architects with the Pesaro Architects Association, opening May 16 at the Pescheria Foundation as a contribution to Pesaro Capitale della Cultura 2024.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1091.jpg",
      "link": "https://ordinearchitetti.mi.it/it/formazione/eventi-formativi/festival-cara-casa-workshop-nuovi-paesaggi-domestici",
      "titolo": "CARA CASA.The Travelling Festival on Housing"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The Social Housing Foundation is organizing, with the Foundation of the Architects' Association of Milan, two workshops dedicated to the theme of new domestic landscapes. Paolo Danelli speaks at the workshop “New Domestic Landscapes: rethinking the spaces of the home.”")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1090.jpg",
      "link": "https://www.ilqi.it/stagione/dirette",
      "titolo": "QUOTIDIANO IMMOBILIARE,  LE DIRETTE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Elena Sacco is the protagonist of QI Le Dirette. The latest work of DAP studio is presented with particular emphasis on the topic of the PNRR. Il Quotidiano Immobiliare, an important online magazine focused on the real estate world in Italy, is a point of reference for professionals in the sector")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1092.jpg",
      "link": "https://www.archilovers.com/projects/287472/UNA-PISCINA-TRA-IL-MAR-IONIO-E-LETNA.html",
      "titolo": "BEST PROJECT 2023"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Our Villa in Sicily is among the Best on Archilovers 2023. Thanks to all the 'lovers' who, once again this year, voted for a DAP studio project!\"")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1089.jpg",
      "link": "https://www.inarch.it/rigenerazione-urbana-viaggio-nel-territorio-lombardo-2/",
      "titolo": "Milano-Varese: the railway as an opportunity for regeneration"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio speaks at the conference at the ANCI headquarters in Milan with the presentation of \"ViviBusto 2030\" project  for the regeneration of the historic center of Busto Arsizio.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1080.jpg",
      "link": "https://500x100.com/it/conversation-between-paolo-danelli-e-elena-sacco-alfonso-femia-giorgio-tartaro-500x100-tivu-2021/",
      "titolo": "500x100 SETALK"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("On December 21, 2021, Elena Sacco and Paolo Danelli participate in 500x100 SETALK, in dialogue with Alfonso Femia and Giorgio Tartaro. An opportunity for discussion about the city and architecture.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1081.jpg",
      "link": "https://www.matrix4design.com/it/architettura/ritorno-alla-natura-una-villa-da-sogno-in-sicilia/?rm=1",
      "titolo": "Back to nature: a dream villa in Sicily"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Matrix4Design publishes the Villa in Sicily in Piedimonte Etneo designed by DAP studio ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1077.jpg",
      "link": "https://ordinearchitetti.ge.it/contemporaneamente-i-vincitori-del-video-contest-sul-tema-dellinclusivita/",
      "titolo": "PIAZZA GIARDINO, AWARDED VIDEO"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("“Piazza Giardino” by Alberto Danelli, is the winner of the video contest “Contemporaneamente” on the theme of inclusiveness."), _c('br'), _vm._v("Screening of works during Genova BeDesign Week 2022, awards ceremony on May 21, 2022")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1078.jpg",
      "link": "https://www.youtube.com/watch?v=Kldw8XEwyas",
      "titolo": "WOW! Webmagazine"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("In this video interview, Elena Sacco e Michele Cortinovis of DAP Studio explains how the new GFT HQ shapes the new values of the post-pandemic workplace. The office becomes a temporary meeting point where to informally discuss and trigger common creative processes.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1074.jpg",
      "link": "/inside/progetto/p133",
      "titolo": "Fitting room n. 16, Arcimboldi Theater"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio presents the Dressing Room n. 16 at the Arcimboldi Theater in Milan, designed within the contest \" Vietato l’ingresso\". The new fitting rooms have been opened to the public during the Salone del Mobile 2021")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1073.jpg",
      "link": "/inside/progetto/p128",
      "titolo": "Ferrucci 112 in Turin: a new office landscape"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The magazine Il Sole 24 Ore NT+ publishes the new GFT Headquarter in Turin, inside the former Fiat Engineering completed in the early 1980s by Ludovico Quaroni and Studio Passarelli, now home to offices and innovative realities. ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1070.jpg",
      "link": "https://www.comunitaresilienti.com/",
      "titolo": "Biennale di Venezia 2021: “Detox” by RebelArchitette at the Padiglione Italia"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Detox will give voice to the work of excellence of Italian architects, including Elena Sacco, DAP studio. The event will be located in the Italian Pavilion Resilient Communities  of the 17th Venice Architecture Biennale with the theme \"How will we live together?\" ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1065.jpg",
      "link": "/inside/progetto/p128",
      "titolo": "Ex Fiat Engineering and new GFT Headquarter"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("GFT is opening a second Turin headquarter in Corso Ferrucci. A new project by DAP studio, characterized by cylindrical volumes modulating the passage from the public areas to the operating ones.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1066.jpg",
      "link": "#!",
      "titolo": "CULTURAL CENTER IN THE FORMER CASERMA GARIBALDI"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("In the courtyard of the Garibaldi Barracks in Varese, DAP studio is designing a new volume, large, visible and impactful, which will  create a physical connection with the historic building. The extension will contain the core functions of a modern “open library”: spaces for consultation, reading and study. ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1060.jpg",
      "link": "https://www.artopiagallery.net/i-love-the-gallery-viewing-room",
      "titolo": "I LOVE THE GALLERY"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("\"\"I love the gallery\" is an exhibition about the  20-years history of  Artopia and it is set up in a fascinating abandoned laboratory of the late 19th century. It's a turning point for Rita Urso, who will soon be moving her gallery to this space. DAP studio, which designed the current gallery, is now working on the new project ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1059.jpg",
      "link": "https://www.internimagazine.it/news/residenza-universitaria-torino/",
      "titolo": "Residence Palestro 3 on Interni, Domusweb, Abitare e many others"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("While the lockdown emptied the university, we came back to Turin to capture  the total transformation and return to its former glory of a mid-nineteenth-century building, located between Piazza Castello and Porta Susa.  In these last months there have been many publications, on Domus, Abitare, Interni, il Sole 24 Ore, Modulo and many others")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1063.jpg",
      "link": "#!",
      "titolo": "A new hub for culture"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("A large Multifunctional Center that will house a library, offices and cultural related services. It is the new project on which DAP studio is working together with 3+Progetti and other partners for the Municipality of Malnate ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1057.jpg",
      "link": "https://www.abitare.it/it/habitat/urban-design/2020/12/19/nuova-piazza-nuova-vita/",
      "titolo": "PIAZZA-GIARDINO ON ABITARE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("With vibrancy and precision DAP studio regenerated a square in Garbagnate (Milan), that today serves as a new landmark for the community")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1054.jpg",
      "link": "https://www.archilovers.com/projects/269606/teatro-teca-centro-per-la-musica.html",
      "titolo": "BEST ARCHILOVERS 2020"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Teca Teather has been included by Archilovers in the best projects of 2020")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1049.jpg",
      "link": "https://youtu.be/MI-n7dCQ69k",
      "titolo": "FOODIES CHALLENGE "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio participates in Foodies Challenge, the contest requires to chefs and designers to elaborate new food & design concepts and to express them through visual arts.  The chefs involved in the team are Elisabetta Danelli and Luigi Cattaneo, the video “Foodscape” has been made by Alberto Danelli and Piera Leonetti. "), _c('br'), _vm._v("This edition of the contest proposes the use of cutting boards, coming from the alpine woods of the Val di Fiemme which have been uprootd by bad weather: haute cuisine and creativity are declined to support areas affected by climate change.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1048.jpg",
      "link": "#!",
      "titolo": "SMARTWORKING MODE"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("In this moment of health emergency we are working in smartworking mode, from our homes, connected to each other thanks to a digital platform that allows us to work and carry on our projects!")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1047.jpg",
      "link": "#!",
      "titolo": "VILLA IN SICILY"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("In the fascinating landscape of north-eastern Sicily, between citrus groves and lava ash, the construction of one of our latest projects is now completed, a villa on one floor with large windows that open to the nature, a swimming pool on the roof and sliding  wood panels  that can be used to filter the relationship with the outside.")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1043.jpg",
      "link": "/inside/progetto/p107",
      "titolo": "INAUGURATED THE SOCIAL HOUSING BRAGARINA"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The new Social Housing residential complex, on the initiative of the Liguria Social Housing Fund, was inaugurated in La Spezia  The complex, designed by DAP studio and Progetec on behalf of DeA Capital Real Estate SGR, consists of 63 apartments, a ground floor for commercial use, and housing services that can also be used by the surrounding neighbourhood, for a total of 7,000 square meters. This new presence will encourage a strong urban renewal for the nearby areas thanks to its architectural quality, and to the building’s criteria applied in the design: high safety, energy, and environmental sustainability performance. ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1035.jpg",
      "link": "https://www.archdaily.com/897936/music-center-theater-teca-dapstudio-elena-sacco-nil-paolo-danelli",
      "titolo": "ARCHDAILY PUBLISHES THE TECA CENTER  "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Archdaily - one of the most visited architecture platform - published the project Centro della Musica. Recently inaugurated in Cassano d’Adda, it is among DAP studio’s best designs.  The Center was built with the aim to spread music culture, especially among young people, and yet  became an attractive site for the whole urban area. It hosts a music school, an auditorium with 300 seats, and a commercial space. ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1039.jpg",
      "link": "/inside/progetto/p115",
      "titolo": "OPENED THE CAMPUS PALESTRO 3, TORINO "
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("The new residence in via Palestro 3 in Turin has been opened to students, promoted by the owner Reale Immobili based on a project by DAP studio and managed by Camplus, a housing provider for students present all over Italy. The structure is the result of the refurbishment of a historic building turned from office to residence, with relational spaces and common areas. The campus can accommodate about 80 students in 19 apartments and provides any sort of services, including gym, laundry and study areas. ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1032.jpg",
      "link": "#!",
      "titolo": "CONVERSATIONS IN SICILY"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("DAP studio participates in the study day: \"Interno / Esterno - conversazioni in Sicilia\". During the meeting, some projects that explore the topic of indoor/outdoor architecture will be presented. The event, in the Conference Room of the Palazzo di Città di Acireale, is part of the cycle of meetings \"Conversazioni in Sicilia, dibattiti di architettura\", organized by the Order of Architects and the Order of Engineers of the city of Catania. ")])]), _vm._v(" "), _c('news', {
    attrs: {
      "image": "1036.jpg",
      "link": "#!",
      "titolo": "RETHINKING A WAY OF LIVING, TORINO"
    }
  }, [_c('div', {
    slot: "descrizione"
  }, [_vm._v("Paolo Danelli is one of the lecturer of the international seminar \" Riqualificazione dell’abitare quali sfide per il XXI secolo?\", Organized in Turin at the Lingotto by PUCA - Plan Urbanisme Construction Architecture, in partnership with the Department of Architecture and Design of the Polytechnic of Turin as part of the REHA research and development program. DAP studio shows its work and its design strategies in the dedicated section to Italian historical construction.")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-23f5854f"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 356
// module chunks = 0